import { render, staticRenderFns } from "./IconPresetAll.vue?vue&type=template&id=5cd1048d&scoped=true&"
import script from "./IconPresetAll.vue?vue&type=script&lang=js&"
export * from "./IconPresetAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1048d",
  null
  
)

export default component.exports